import React from 'react';
import { useTranslation } from 'react-i18next';

import Card from '../../../../components/Card';
import DateTime from '../../../../components/DateTime';

import './style.scss';

export interface NodeProjectCardProps {
  title: string;
  subtitle?: string;
  image?: React.ReactNode;
  link: string;
  themes?: string[];
  durationStartDate?: string;
  durationEndDate?: string;
  researchLeader?: string;
  langcode: 'nl' | 'en';
}

const NodeProjectCard: React.FC<NodeProjectCardProps> = (props) => {
  const {
    title,
    subtitle,
    image,
    link,
    themes,
    durationStartDate,
    durationEndDate,
    researchLeader,
    langcode,
  } = props;

  const { t } = useTranslation();

  return (
    <Card className="NodeProjectCard">
      <Card.Content>
        <div className="Card__image-wrapper">
          {image && (
            <Card.Image
              image={image}
            />
          )}
        </div>

        <div className="Card__content__text">
          {((themes && themes.length > 0) || (durationStartDate && durationEndDate)) && (
            <div className="Card__content__metadata">
              {(themes && themes.length > 0) && (
                <Card.Tags
                  tags={themes.map((theme) => ({ name: theme, type: 'themes' }))}
                />
              )}

              {(durationStartDate && durationEndDate) && (
                <DateTime
                  date={new Date(durationStartDate)}
                  endDate={new Date(durationEndDate)}
                  translationKey="content_types.project.duration.datetime"
                  langcode={langcode}
                />
              )}
            </div>
          )}

          <Card.Link href={link}>
            <Card.Title title={title} />
          </Card.Link>

          {subtitle && (
            <Card.Subtitle
              subtitle={(
                <p className="u-truncate--2 body--small">
                  {subtitle}
                </p>
              )}
            />
          )}


          {researchLeader && (
            <Card.Subtitle
              className="body--small"
              subtitle={t('content_types.project.research_leader_title', { name: researchLeader })}
            />
          )}
        </div>
      </Card.Content>
    </Card>
  );
};

export default NodeProjectCard;
